import type Phaser from "phaser";

/** A tiny runtime holder so DOM UI modules can reach the Phaser game. */
export const runtime: { game?: Phaser.Game } = {};

export function setGame(game: Phaser.Game): void {
  runtime.game = game;
}

export function setGameKeyboardEnabled(enabled: boolean): void {
  const game = runtime.game;
  if (!game) return;
  if (game.input.keyboard) game.input.keyboard.enabled = enabled;
  // Scenes read their own KeyboardPlugin, and the disabled manager drops the
  // key-up events, so held keys must be released explicitly.
  for (const scene of game.scene.getScenes(true)) {
    const keyboard = scene.input.keyboard;
    if (!keyboard) continue;
    keyboard.enabled = enabled;
    keyboard.resetKeys();
  }
}

export function isTextInputFocused(): boolean {
  const el = document.activeElement;
  if (!el) return false;
  const tag = el.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || (el as HTMLElement).isContentEditable;
}

/** Focus is in a text field or inside a UI panel, so game hotkeys must not fire. */
export function isUiFocused(): boolean {
  if (isTextInputFocused()) return true;
  return !!document.activeElement?.closest("[data-ui-panel]");
}
